import React, { Component } from 'react';
import {  BrowserRouter as Router, Route, Switch } from 'react-router-dom';

import Header from './components/Global/Header';
import Main from './components/Global/Header/Main';
import MenuApplications from './components/Menu/MenuApplications';
import SoftaculousApp from './components/SoftaculousApp';
import { NewString } from './functions/ReplaceCharacter';

class App extends Component {
  render() {
    return (
      <Router>
        <div>
          <Switch>

            <Route exact path="/" component={ () => {
              return (
                <div>
                  <Header optionView = "0" />
                  <main role="main">
                    <Main />
                    <MenuApplications />
                  </main>
                </div>
              )
            }} />

            <Route path="/application/:app_name/:cat_name" component = { (param) => {
              let app_name = NewString(param.match.params.app_name, 4);
              let cat_name = NewString(param.match.params.cat_name, 4);

              return (
                <div>
                  <Header optionView = "1" />
                  <SoftaculousApp
                    app_name = { app_name }
                    cat_name = { cat_name }
                  />
                </div>
              )
            }} />

          </Switch>

        </div>
      </Router>
    )
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js